export const language = {
  en: {
    "International Logistics": "International Logistics",
    "Create Shipment": "Create Shipment",
    "Create": "Create",
    "Logistic Tracker": "Logistic Tracker",
    "Import & Export": "Import & Export",
    "Sea Shipment": "Sea Shipment",
    "Air Shipment": "Air Shipment",
    "Please select carrier": "Please select carrier",
    "Please enter B/L number": "Please enter B/L number",
    "Please enter container number": "Please enter container number",
    "Start": "Start",
    "Basic Information": "Basic Information",
    "B/L No.": "B/L No.",
    "Carrier": "Carrier",
    "Container Quantity": "Container Quantity",
    "Container No.": "Container No.",
    "Container Size": "Container Size",
    "GrossWeight（KGS）": "GrossWeight（KGS）",
    "Number of Packages": "Number of Packages",
    "Seal Number": "Seal Number",
    "Order No./Contract No.": "Order No./Contract No.",
    "Invoice No.": "Invoice No.",
    "Loading Details": "Loading Details",
    "Add": "Add",
    "Product Name": "Product Name",
    "Specification": "Specification",
    "Packing Unit": "Packing Unit",
    "Weight（KGS）": "Weight（KGS）",
    "Quantity": "Quantity",
    "Remark": "Remark",
    "Operation": "Operation",
    "Delete": "Delete",
    "Document": "Document",
    "Upload B/L": "Upload B/L",
    "Format:jpg/png/pdf": "Format:jpg/png/pdf",
    "Certificate of Origin": "Certificate of Origin",
    "Packing List": "Packing List",
    "Upload ISO2000": "Upload ISO2000",
    "Upload HACCP": "Upload HACCP",
    "HACCP": "HACCP",
    "others": "others",
    "Upload other files": "Upload other files",
    "Contact": "Contact",
    "Consigner": "Consigner",
    "Please enter name": "Please enter name",
    "Please enter Tel / Email": "Please enter Tel / Email",
    "Consignee": "Consignee",
    "Transportation Route": "Transportation Route",
    "Vessel Name": "Vessel Name",
    "Voyage": "Voyage",
    "Origin": "Origin",
    "Country/Region": "Country/Region",
    "City/Port code": "City/Port code",
    "Clear all": "Clear all",
    "Confirm": "Confirm",
    "Destination": "Destination",
    "Please select": "Please select",
    "Depart": "Depart",
    "Date": "Date",
    "Arrival": "Arrival",
    "B/L / Container/Order/ Contract": "B/L / Container/Order/ Contract",
    "PLease enter": "PLease enter",
    "Screen": "Screen",
    "Sort": "Sort",
    "Est Depart Time": "Est Depart Time",
    "Est Arrival Time": "Est Arrival Time",
    "Transport Status": "Transport Status",
    "In Transit": "In Transit",
    "Arrived": "Arrived",
    "ETD": "ETD",
    "ETA": "ETA",
    "ATD": "ATD",
    "ATA": "ATA",
    "View More": "View More",
    "B/L": 'B/L',
    "Container": "Container",
    "GrossWeight": "GrossWeight",
    "Order#/Contract#": "Order#/Contract#",
    "Max Size is 14": "Max Size is 14",
    "Max Size is 200MB": "Max Size is 200MB",
    "Upload Failed": "Upload Failed",
    "CARTONS": "CARTONS",
    "PIECE": "PIECE",
    "TRAY": "TRAY",
    "PALLET": "PALLET",
    "Return": "Return",
    "Getting data, you can try": "Getting data, you can try",
    "Refresh": " Refresh",
    "No Data": "No Data",
    "Hello": "Hello",
    "Share": "Share",
    "share with you": "share with you",
    "logistics information": "logistics information",
    "Click on the link to view": "Click on the link to view",
    "Subscribe": 'Subscribe',
    "Subscribed": "Subscribed",
    "Mail": "Mail",
    "Phone": "Phone",
    "Hello, you don't have the permission to subscribe to logistics information, please contact the administrator": "Hello, you don't have the permission to subscribe to logistics information, please contact the administrator",
    "Copy": "Copy",
    "Cancel": "Cancel",
    "Copied": "Copied",
    "Copy failed": "Copy failed",
    "Email": "Email",
    "Tel No": "Tel No",
    "Successfully subscribed to this shipping message": "Successfully subscribed to this shipping message",
    "Unsubscribed from this shipping message": "Unsubscribed from this shipping message",
  },
  zh: {
    "International Logistics": "国际物流服务",
    "Create Shipment": "创建物流单",
    "Create": "创建",
    "Logistic Tracker": "物流追踪",
    "Import & Export": "进出口政策服务",
    "Sea Shipment": "海运",
    "Air Shipment": "空运",
    "Please select carrier": "请选择船公司",
    "Please enter B/L number": "请输入提单号",
    "Please enter container number": "请输入集装箱号",
    "Start": "开始创建",
    "Basic Information": "基本信息",
    "B/L No.": "B/L 提单号",
    "Carrier": "船运公司",
    "Container Quantity": "集装箱数",
    "Container": "集装箱",
    "Container No.": "集装箱号",
    "Container Size": "集装箱尺寸",
    "GrossWeight（KGS）": "发货总重量（KGS）",
    "Number of Packages": "件数",
    "Seal Number": "封箱号",
    "Order No./Contract No.": "订单号/合同编号",
    "Invoice No.": "发票号",
    "Loading Details": "装箱信息",
    "Add": "新增",
    "Product Name": "商品名称",
    "Specification": "商品规格",
    "Packing Unit": "装箱单位",
    "Weight（KGS）": "装箱重量（KGS）",
    "Quantity": "装箱数量",
    "Remark": "备注",
    "Operation": "操作",
    "Delete": "删除",
    "Document": "单据信息",
    "Upload B/L": "上传提单（正/副本）",
    "Format:jpg/png/pdf": "支持扩展名：jpg、png、pdf",
    "Certificate of Origin": "原产地证明",
    "Packing List": "装箱单",
    "Upload ISO2000": "上传ISO2000",
    "Upload HACCP": "上传HACCP证书",
    "HACCP": "HACCP证书",
    "Upload other files": "上传其他",
    "others": "其他",
    "Contact": "联系信息",
    "Consigner": "发货人",
    "Please enter name": "请输入姓名",
    "Please enter Tel / Email": "请输入联系方式",
    "Consignee": "收货人",
    "Transportation Route": "运输路径",
    "Vessel Name": "船舶号",
    "Voyage": "船次号",
    "Origin": "出发国家/港口",
    "Country/Region": "国家/地区",
    "City/Port code": "城市/港口代码",
    "Clear all": "清空",
    "Confirm": "确认",
    "Destination": "目的国家/港口",
    "Please select": "请选择",
    "Depart": "预计离港时间",
    "Date": "请选择日期",
    "Arrival": "预计到港时间",
    "B/L / Container/Order/ Contract": "B/L提单号/集装箱号/订单号",
    "PLease enter": "请输入",
    "Screen": "筛选器",
    "Sort": "排序",
    "Est Depart Time": "预计离港时间",
    "Est Arrival Time": "预计到港时间",
    "Transport Status": "运输状态",
    "In Transit": "运输中",
    "Arrived": "已到港",
    "ETD": "预计离港时间",
    "ETA": "预计到港时间",
    "ATD": "实际离港时间",
    "ATA": "实际到港时间",
    "View More": "查看更多",
    "B/L": "B/L 提单号",
    "GrossWeight": "运输总重量(KGS)",
    "Order#/Contract#": "订单号/合同号",
    "Max Size is 14": "最多上传14个文件",
    "Max Size is 200MB": "请上传小于200MB的文件",
    "Upload Failed": "上传失败",
    "CARTONS": "箱",
    "PIECE": "件",
    "TRAY": "盘",
    "PALLET": "托盘",
    "Return": "返回",
    "Getting data, you can try": "数据获取中，您可以尝试",
    "Refresh": "刷新",
    "No Data": "暂无搜索结果",
    "Hello": "您好",
    "Share": "分享",
    "share with you": "向您分享",
    "logistics information": "的物流信息",
    "Click on the link to view": "点击链接查看",
    "Subscribe": '订阅',
    "Subscribed": '已订阅',
    "Mail": "邮箱",
    "Phone": "电话",
    "Hello, you don't have the permission to subscribe to logistics information, please contact the administrator": "您好，您还没有订阅物流信息权限，请联系管理员开通",
    "Copy": "复制",
    "Cancel": "取消",
    "Copied": "拷贝成功",
    "Copy failed": "拷贝失败",
    "Email": "邮箱",
    "Tel No": "电话",
    "Successfully subscribed to this shipping message": "您已成功订阅该条物流信息",
    "Unsubscribed from this shipping message": "您已取消订阅该条物流信息",
  },
};
